import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Header } from 'components/organisms/header';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
  },
  content: {
    textAlign: 'center',
    paddingTop: '20px',
    height: 'calc(100vh - 64px)',
  },
}));

export const Layout: React.FC = ({ children }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Header />
      <main className={classes.content}>{children}</main>

      { /* footer 的な何かが必要になったら */}
    </div>
  );
};
